// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const TeamsSelectPlanModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "teamsselectplanmodalcontainer" */ "./TeamsSelectPlanModalContainer")).then((bundle)=>{
        return {
            default: bundle.TeamsSelectPlanModalContainer
        };
    });
export const LazyTeamsSelectPlanModalContainer = /*#__PURE__*/ lazy(TeamsSelectPlanModalContainerLazyLoader);
